/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Empty_MoneyInputs */

const vi_my_grower_report_empty_money = /** @type {(inputs: My_Grower_Report_Empty_MoneyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa nhận khoản tiền chè nào trong khoảng thời gian trên.`)
};

/**

* @param {My_Grower_Report_Empty_MoneyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_empty_money = /** @type {((inputs?: My_Grower_Report_Empty_MoneyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Empty_MoneyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_empty_money(inputs)
});